@import "styles/variables";

.accountDetails {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  background-color: rgba(0,0,0,.5);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.message {
  position: absolute;
  bottom: 20px;
  left: 15px;
  padding: 20px;
  background: #fff;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  width: calc(100% - 70px);
}

.account-inputs {
  margin-top: 20px;
  >:first-child {
    margin-bottom: 10px;
  }
}

.buttonContainer {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.buttonContainer button {
  width: calc(50% - 10px);
}